export default __webpack_public_path__ + "static/media/medium.15ef09fd.png";